import PropTypes from 'prop-types';
import { MODAL, SUPPORTED_LAYOUTS } from './flowLayouts';

/**
 * applyParameters are supplied by the front and contains data related to the apply button/link
 * initializerData is supplied by the back end and contains data related to the job itself
 * applyData combines applyParameters and initializerData to send to individual Screen components
 */

// applyParameters are used by various entrypoints to initialize the Apply Flow App
export const applyParametersPropTypes = PropTypes.shape({
  ab_tests: PropTypes.object,
  areaName: PropTypes.string.isRequired,
  encryptedQuizId: PropTypes.string.isRequired,
  layout: PropTypes.oneOf(SUPPORTED_LAYOUTS),
  method: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  redirectAfterApply: PropTypes.bool,
  listingVersionKey: PropTypes.string.isRequired,
  placementId: PropTypes.number.isRequired,
});

export const applyParametersProps = {
  ab_tests: {},
  layout: MODAL,
  onDone: () => {},
  redirectAfterApply: false,
};

// applyData is passed from the Apply Flow App to individual Screens
export const applyDataPropTypes = PropTypes.shape({
  areaName: PropTypes.string.isRequired,
  autologin: PropTypes.bool.isRequired,
  company_logo: PropTypes.string,
  company_name: PropTypes.string.isRequired,
  encPlacementId: PropTypes.string,
  encryptedQuizId: PropTypes.string.isRequired,
  encrypted_contact_id: PropTypes.string,
  encrypted_response_id: PropTypes.string,
  is_mobile: PropTypes.bool.isRequired,
  job_location: PropTypes.string.isRequired,
  job_title: PropTypes.string.isRequired,
  layout: PropTypes.oneOf(SUPPORTED_LAYOUTS),
  method: PropTypes.string.isRequired,
  onDone: () => {},
  placementId: PropTypes.string,
  resume_required: PropTypes.bool.isRequired,
});
